const { network, setting, antd } = require("./default");

module.exports = Object.assign({}, network, setting);
